import React from 'react'
import { observer } from 'mobx-react'
import Skeleton from 'react-loading-skeleton'
import { withTranslation } from 'react-i18next'

import { getRandomIntInclusive } from '@flowwai-frontend/shared/utils/common'
import { isMobileDevice } from '@flowwai-frontend/shared/utils/web'

import { WithTranslation } from '../../../types'

import { FullScreenLoader } from '../../LoadingWrapper/LoadingView'
import { REACT_LOADING_DURATION } from '../../Loader/constants'

import TaskManagementHeaderLoader from '../TaskManagementHeaderLoader'
import { ReactContentLoaderProps } from '../types'

import {
   YourProjectsLoadingWrapper,
   ProjectLoadingWrapper,
   ProjectPrefixAndDisplayNameLoadingWrapper,
   ContentLoadingWrapper,
   IconAndTextWrapper,
   ProjectsListLoadingWrapper,
   ProjectsRouteHeader,
   YourProjectsTitleLoader,
   YourProjectsRouteLoadingWrapper
} from './styledComponents'

interface YourProjectsRouteLoaderProps
   extends ReactContentLoaderProps,
      WithTranslation {
   isFromWithProjectsList?: boolean
}
class YourProjectsRouteLoader extends React.Component<
   YourProjectsRouteLoaderProps
> {
   numberOfProjects = 8

   renderProjectPrefixAndDisplayNameLoader = () => (
      <ProjectPrefixAndDisplayNameLoadingWrapper>
         <Skeleton
            duration={REACT_LOADING_DURATION}
            width={40}
            height={40}
            style={{ borderRadius: 6 }}
         />
         <Skeleton
            duration={REACT_LOADING_DURATION}
            width={getRandomIntInclusive(100, 300)}
            height={20}
            style={{ marginLeft: 12 }}
         />
      </ProjectPrefixAndDisplayNameLoadingWrapper>
   )
   renderContentLoader = () => (
      <ContentLoadingWrapper>
         <IconAndTextWrapper>
            <Skeleton
               duration={REACT_LOADING_DURATION}
               width={24}
               height={24}
            />
            <Skeleton
               duration={REACT_LOADING_DURATION}
               width={80}
               height={14}
               style={{ marginLeft: 8 }}
            />
         </IconAndTextWrapper>
         <IconAndTextWrapper>
            <Skeleton
               duration={REACT_LOADING_DURATION}
               width={24}
               height={24}
            />
            <Skeleton
               duration={REACT_LOADING_DURATION}
               width={120}
               height={14}
               style={{ marginLeft: 8 }}
            />
         </IconAndTextWrapper>
      </ContentLoadingWrapper>
   )
   yourProjectsListLoader = () => {
      const {
         renderProjectPrefixAndDisplayNameLoader: RenderProjectPrefixAndDisplayNameLoader,
         renderContentLoader: RenderContentLoader
      } = this
      return (
         <YourProjectsLoadingWrapper>
            {Array.from(Array(this.numberOfProjects).keys()).map(index => (
               <ProjectLoadingWrapper key={index}>
                  <RenderProjectPrefixAndDisplayNameLoader />
                  <RenderContentLoader />
               </ProjectLoadingWrapper>
            ))}
         </YourProjectsLoadingWrapper>
      )
   }
   renderProjectsRouteHeader = () => {
      const { t } = this.props
      return (
         <ProjectsRouteHeader>
            <YourProjectsTitleLoader>
               {t('workflowManagement:yourProjects.yourProjects')}
            </YourProjectsTitleLoader>
         </ProjectsRouteHeader>
      )
   }
   render() {
      if (isMobileDevice) {
         return <FullScreenLoader />
      }
      const {
         yourProjectsListLoader: YourProjectsListLoader,
         renderProjectsRouteHeader: RenderProjectsRouteHeader
      } = this
      const { isFromWithProjectsList } = this.props
      return (
         <YourProjectsRouteLoadingWrapper>
            {isFromWithProjectsList && <TaskManagementHeaderLoader />}
            <ProjectsListLoadingWrapper>
               <RenderProjectsRouteHeader />
               <YourProjectsListLoader />
            </ProjectsListLoadingWrapper>
         </YourProjectsRouteLoadingWrapper>
      )
   }
}

export default withTranslation()(observer(YourProjectsRouteLoader))
